fragment UserEmail on UserEmail {
    id
    isEnabledForSending
    sendErrors
    isSyncEnabled
    syncErrors
    allowsEmailSync
    address
    display
    formatted
    type
    smtpCredentials {
        settings {
            hostname
            username
            password
            ssl
            port
        }
        verificationStatus
        verificationMessage
    }
}
